import { VolleyballEventStatusId } from '@collector/sportsapi-client-legacy'

export const eventStatuses: VolleyballEventStatusId[] = [
  VolleyballEventStatusId.NotStarted,
  VolleyballEventStatusId.StartDelayed,
  VolleyballEventStatusId.Postponed,
  VolleyballEventStatusId.FirstSet,
  VolleyballEventStatusId.BreakAfterFirstSet,
  VolleyballEventStatusId.SecondSet,
  VolleyballEventStatusId.BreakAfterSecondSet,
  VolleyballEventStatusId.ThirdSet,
  VolleyballEventStatusId.BreakAfterThirdSet,
  VolleyballEventStatusId.FourthSet,
  VolleyballEventStatusId.BreakAfterFourthSet,
  VolleyballEventStatusId.FifthSet,
  VolleyballEventStatusId.BreakAfterFifthSet,
  VolleyballEventStatusId.GoldenSet,
  VolleyballEventStatusId.Interrupted,
  VolleyballEventStatusId.Abandoned,
  VolleyballEventStatusId.Finished,
  VolleyballEventStatusId.FinishedAwardedWin,
  VolleyballEventStatusId.Cancelled,
  VolleyballEventStatusId.ToFinish,
]
